import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import {AgGridReact} from "ag-grid-react";
import aggridUtils from "../../../../utils/aggrid-utils.js";
import {DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL} from "../../../../utils/ag-grid-columns-utils.js";
import InputForm from "../../../../components/input/input-form.jsx";
import React, {useCallback, useMemo, useRef, useState} from "react";
import {FaSearch} from "react-icons/fa";
import {useQuery} from "@tanstack/react-query";
import vmsService from "../../../../services/web/vms-service.js";
import Loader from "../../../../components/template/loader.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";

const VehiclesModalCameraTable = ({showModal, setShowModal, data, setData, disabled = false}) => {
  const [filter, setFilter] = useState("");
  const gridApi = useRef(null);
  const MAX_SELECTION = 4;
  const selectionOrder = useRef([]);
  const IconRenderer = ({ value }) => {
    const color = "#" + (value ?? "606061");

    return (
      <div className="flex h-full items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={20}>
          <path
            d="m512,256C512,114.69,397.48,0,256,0S0,114.52,0,256s114.52,256,256,256c141.48-.17,256-114.69,256-256Z"
            style={{ fill: "#fff" }}
          />
          <path
            d="m489.64,256c0-129.02-104.62-233.64-233.64-233.64S22.36,126.81,22.36,256s104.62,233.64,233.64,233.64c129.19-.17,233.64-104.79,233.64-233.64Z"
            style={{ fill: color }}
          />
          <path
            d="m105.81,248.32v-50.69c0-21.5,17.41-38.91,38.91-38.91h144.21c19.29-2.22,36.69,11.44,38.91,30.72.34,2.73.34,5.46,0,8.36v112.98c2.22,21.33-13.48,40.45-34.82,42.67-1.36,0-2.73.17-4.1.17h-144.21c-22.19-2.05-39.08-20.65-38.91-42.84v-62.46Z"
            style={{ fill: "#fff" }}
          />
          <path
            d="m327.85,228.86l58.37-50.69c4.61-4.61,11.95-4.61,16.55,0,3.07,3.07,4.27,7.68,2.9,11.78v128.51c1.88,6.14-1.54,12.8-7.68,14.68-4.1,1.37-8.7,0-11.78-2.9l-58.37-50.69c-14-5.63-20.82-21.5-15.19-35.5,2.73-7,8.19-12.46,15.19-15.19Z"
            style={{ fill: "#fff" }}
          />
        </svg>
      </div>
    );
  };

  const columnsDef = useMemo(() => [
    {headerName: "ID", field: "id", flex: 1},
    {headerName: "Ícone", field: "iconColor", flex: 1,
      cellRenderer: IconRenderer},
    {headerName: "Nome", field: "cameraName", flex: 2, filter: true},
    {headerName: "Vms", field: "vmsName", flex: 2},
    {headerName: "Marcadores", field: "labels", flex: 2, filter: true},
    {headerName: "Sistema de câmeras", field: "dvrName", flex: 3, filter: true},
  ],[])

  const {data: cameras = [], isLoading, refetch} = useQuery({
    queryFn: vmsService.list,
    queryKey: ["cameras"]
  })

  const search = useCallback(() => {
    if(disabled || !gridApi.current) return;
    gridApi.current.setGridOption("quickFilterText", filter);

  }, [filter])

  // não salva no servidor, apenas adiciona na lista
  const save = () => {
    if(!gridApi.current) return;

    const data = gridApi.current.getSelectedRows();

    if(data.length > 4) {
      projectUtils.swalErrorMessage("", "Limite máximo de 4 câmeras.")
      return;
    }

    const cameraToAdd = data.map(camera => {
      const {id, cameraName, vmsName, vmsId} = camera;
      return {
        cameraId: id, cameraName, vmsName, vmsId
      };
    })

    setData(prev => ({...prev, video_cameras: cameraToAdd}))

    setShowModal(false);
  }

  const onRowSelected = (event) => {
    const node = event.node;

    if (node.isSelected()) {
      selectionOrder.current.push(node);

      if (selectionOrder.current.length > MAX_SELECTION) {
        const first = selectionOrder.current.shift();
        first.setSelected(false);
      }
    } else {
      selectionOrder.current = selectionOrder.current.filter(n => n !== node);
    }
  };

  useGlobalKey("Enter", search);

  return(
    <Modal open={showModal} setOpen={setShowModal} title="Selecionar câmeras">
      {isLoading && <Loader />}
      <Modal.Body>
        <div className="flex gap-2">
          <div className="flex-1">
            <InputForm
              label="Pesquisa"
              value={filter}
              onChange={({target}) => setFilter(target.value)}
            />
          </div>
          <Button title="Buscar" onClick={search}><FaSearch/></Button>
        </div>
        <div className="aggrid-row-pointer h-[400px] mt-2">
          <AgGridReact
            columnDefs={columnsDef}
            onGridReady={params => {
              gridApi.current = params.api
            }}
            rowData={cameras}
            theme={aggridUtils.generalTheme()}
            defaultColDef={DEFAULT_COL_DEF_NO_RESIZE_SUPPRESS_ALL}
            animateRows={false}
            suppressCellFocus={true}
            gridOptions={{localeText: aggridUtils.localization()}}
            getRowId={(params) => params.data.id}
            rowSelection={{
              mode: 'multiRow',
              checkboxes: false,
              enableSelectionWithoutKeys: true,
              headerCheckbox: false,
              enableClickSelection: true
            }}
            onRowSelected={onRowSelected}
            onFirstDataRendered={() => {
              if (!gridApi.current || !data?.length) return;

              data.forEach(camera => {
                console.log(camera)
                const node = gridApi.current.getRowNode(String(camera.cameraId ?? camera.vms_camera_id));
                if (node) {
                  node.setSelected(true);
                }
              });
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={save}>Confirmar</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default VehiclesModalCameraTable;